import React, { MouseEventHandler, ReactNode } from "react"

import {useAccount, useLayerPopupContext} from "@shared/contexts"

import LinkItem from "./LinkItem"

interface Props {
  title: string
  children: ReactNode
  isChatMode: boolean
}

const Setting = ({ title, children, isChatMode }: Props) => {
  const { open } = useLayerPopupContext()
  const { account } = useAccount()
  const isAnomymous = account?.viewer?.role === "ANONYMOUS"

  const handleSettingClick: MouseEventHandler<HTMLAnchorElement> = (e) => {
    e.preventDefault()
    if (isAnomymous) {
      open("ANONYMOUS")
      return
    }

    open("FONT_SETTING")
  }

  return (
    <LinkItem
      className={isChatMode ? "ty04" : "ty05"}
      title={title}
      onClick={handleSettingClick}
    >
      {children}
    </LinkItem>
  )
}

export default Setting
